import { takeLatest, takeLeading, call, put, select } from "redux-saga/effects";
import axiosInstance from "../../global/axiosInterceptor";
import { ASSISTANT_PROMPTS_TYPES, setFavorites } from "../actions/assistantPrompts-actions";
import { showCalibrationBanner } from "../actions";
import { getBillingAccounts } from "../../configuration";

function* fetchAssistantPromptsWorker() {
  try {
    const response = yield call([axiosInstance, "get"], getBillingAccounts());
    const customdata = response?.data?.customdata;
    if (customdata?.assistant_prompts) {
      yield put(setFavorites(customdata.assistant_prompts));
    }
  } catch (err) {
    // Non-critical — local cache via redux-persist is the fallback
    console.warn("Failed to fetch assistant prompts from backend:", err.message);
  }
}

function* patchCustomdataWorker(action) {
  try {
    const { url, method, data } = action.payload;
    const response = yield call(axiosInstance, { url, method, data });
    yield put({ type: ASSISTANT_PROMPTS_TYPES.PATCH_SUCCESS, payload: response });
    const lastToggleAction = yield select((s) => s.assistantPrompts?.lastToggleAction);
    yield put(
      showCalibrationBanner({
        type: "Success",
        priority: "success",
        title: lastToggleAction === "remove" ? "Prompt removed " : "Prompt saved ",
        showNotification: true,
      })
    );
  } catch (err) {
    const lastToggleAction = yield select((s) => s.assistantPrompts?.lastToggleAction);
    const message = err?.response?.data?.message || err.message || "Failed to save";
    yield put({ type: ASSISTANT_PROMPTS_TYPES.PATCH_FAILURE, payload: message });
    yield put(
      showCalibrationBanner({
        type: "Failed",
        priority: "critical",
        title: lastToggleAction === "remove" ? "Error deleting saved prompt" : "Error saving prompt",
        showNotification: true,
      })
    );
  }
}

export default function* assistantPromptsSaga() {
  // takeLeading prevents duplicate fetches if dispatched multiple times rapidly
  yield takeLeading(ASSISTANT_PROMPTS_TYPES.FETCH_REQUEST, fetchAssistantPromptsWorker);
  yield takeLatest(ASSISTANT_PROMPTS_TYPES.PATCH_REQUEST, patchCustomdataWorker);
}
